<script setup>
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const handleProductClick = item => {
  if (item?.action?.type === 'open_url' && item.action.value) {
    window.open(item.action.value, '_blank');
  }
};
</script>

<template>
  <div
    class="text-sm bg-n-solid-blue text-n-slate-12 right-bubble rounded-xl ltr:rounded-br-sm rtl:rounded-bl-sm max-w-lg px-4 py-3"
  >
    <!-- Header -->
    <div
      v-if="contentAttributes?.heading || contentAttributes?.subtext"
      class="px-4 pt-4 pb-2"
    >
      <h6 class="font-semibold text-sm">
        {{ contentAttributes.heading }}
      </h6>
      <p v-if="contentAttributes.subtext" class="text-sm text-n-slate-11 mt-1">
        {{ contentAttributes.subtext }}
      </p>
    </div>

    <!-- Items -->
    <div class="divide-y divide-n-strong">
      <div
        v-for="item in contentAttributes.items"
        :key="item.id"
        class="px-4 py-3 flex gap-3 cursor-pointer hover:bg-n-alpha-1 transition-colors"
        @click="handleProductClick(item)"
      >
        <div class="flex-shrink-0">
          <img
            :src="item.image_url"
            :alt="item.title"
            class="w-12 h-12 rounded-lg object-cover"
            loading="lazy"
            @error="
              e =>
                (e.target.src =
                  'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2248%22 height=%2248%22%3E%3Crect fill=%22%23f0f0f0%22 width=%2248%22 height=%2248%22/%3E%3Ctext fill=%22%23999%22 x=%2250%25%22 y=%2250%25%22 text-anchor=%22middle%22 dy=%22.3em%22%3ENo Image%3C/text%3E%3C/svg%3E')
            "
          />
        </div>

        <div class="flex-1 min-w-0">
          <div class="font-medium text-sm truncate">
            {{ item.title }}
          </div>

          <div
            v-if="item.price"
            class="text-sm font-medium text-n-teal-9 mt-0.5"
          >
            {{ item.price }}
          </div>

          <div v-if="item.meta" class="text-xs text-n-slate-11 mt-0.5 truncate">
            {{ item.meta }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* intentionally empty */
</style>
